"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.parse-int.js");

var _progress = _interopRequireDefault(require("element-ui/lib/progress"));

var _locale = _interopRequireDefault(require("element-ui/lib/mixins/locale"));

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('transition-group', {
    "class": ['el-upload-list', 'el-upload-list--' + _vm.listType, {
      'is-disabled': _vm.disabled
    }],
    attrs: {
      "tag": "ul",
      "name": "el-list"
    }
  }, _vm._l(_vm.files, function (file, index) {
    return _c('li', {
      key: index,
      "class": ['el-upload-list__item', 'is-' + file.status, _vm.focusing ? 'focusing' : ''],
      attrs: {
        "tabindex": "0"
      },
      on: {
        "keydown": function keydown($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete"])) {
            return null;
          }

          !_vm.disabled && _vm.$emit('remove', file);
        },
        "focus": function focus($event) {
          _vm.focusing = true;
        },
        "blur": function blur($event) {
          _vm.focusing = false;
        },
        "click": function click($event) {
          _vm.focusing = false;
        }
      }
    }, [file.status !== 'uploading' && ['picture-card', 'picture'].indexOf(_vm.listType) > -1 ? _c('img', {
      staticClass: "el-upload-list__item-thumbnail",
      attrs: {
        "src": file.url,
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "el-upload-list__item-name",
      attrs: {},
      on: {
        "click": function click($event) {
          _vm.handleClick(file);
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-document",
      attrs: {}
    }), _vm._v(_vm._s(file.name) + "\n    ")]), _vm._v(" "), _c('label', {
      staticClass: "el-upload-list__item-status-label",
      attrs: {}
    }, [_c('i', {
      "class": {
        'el-icon-upload-success': true,
        'el-icon-circle-check': _vm.listType === 'text',
        'el-icon-check': ['picture-card', 'picture'].indexOf(_vm.listType) > -1
      },
      attrs: {}
    })]), _vm._v(" "), !_vm.disabled ? _c('i', {
      staticClass: "el-icon-close",
      attrs: {},
      on: {
        "click": function click($event) {
          _vm.$emit('remove', file);
        }
      }
    }) : _vm._e(), _vm._v(" "), !_vm.disabled ? _c('i', {
      staticClass: "el-icon-close-tip",
      attrs: {}
    }, [_vm._v(_vm._s(_vm.t('el.upload.deleteTip')))]) : _vm._e(), _vm._v(" "), file.status === 'uploading' ? _c('el-progress', {
      attrs: {
        "type": _vm.listType === 'picture-card' ? 'circle' : 'line',
        "stroke-width": _vm.listType === 'picture-card' ? 6 : 2,
        "percentage": _vm.parsePercentage(file.percentage)
      }
    }) : _vm._e(), _vm._v(" "), _vm.listType === 'picture-card' ? _c('span', {
      staticClass: "el-upload-list__item-actions",
      attrs: {}
    }, [_vm.handlePreview && _vm.listType === 'picture-card' ? _c('span', {
      staticClass: "el-upload-list__item-preview",
      attrs: {},
      on: {
        "click": function click($event) {
          _vm.handlePreview(file);
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-zoom-in",
      attrs: {}
    })]) : _vm._e(), _vm._v(" "), !_vm.disabled ? _c('span', {
      staticClass: "el-upload-list__item-delete",
      attrs: {},
      on: {
        "click": function click($event) {
          _vm.$emit('remove', file);
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-delete",
      attrs: {}
    })]) : _vm._e()]) : _vm._e()], 1);
  }));
};

var __vue_staticRenderFns__ = [];
var _default2 = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  mixins: [_locale["default"]],
  data: function data() {
    return {
      focusing: false
    };
  },
  components: {
    ElProgress: _progress["default"]
  },
  props: {
    files: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    handlePreview: Function,
    listType: String
  },
  methods: {
    parsePercentage: function parsePercentage(val) {
      return parseInt(val, 10);
    },
    handleClick: function handleClick(file) {
      this.handlePreview && this.handlePreview(file);
    }
  }
};
exports["default"] = _default2;